import { Controller } from "@hotwired/stimulus"

// Handles individual notification toggle switches.
// Each switch sends a PATCH with { key, unlock } to toggle a notification blocker.
//
// Usage:
//   <div data-controller="manage--notification-toggle"
//        data-manage--notification-toggle-url-value="/manage/slug/admin/settings/notifications">
//     <input type="checkbox" data-action="change->manage--notification-toggle#toggle"
//            data-key="leader_daily_activities_reminder">
export default class extends Controller {
  static values = { url: String }

  toggle(event) {
    const checkbox = event.currentTarget
    const key = checkbox.dataset.key
    const unlock = checkbox.checked

    checkbox.disabled = true

    this.#patch({ key, unlock: String(unlock) })
      .then(() => { checkbox.disabled = false })
      .catch(() => {
        checkbox.checked = !checkbox.checked
        checkbox.disabled = false
      })
  }

  #patch(data) {
    return fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
      },
      body: JSON.stringify(data)
    }).then(response => {
      if (!response.ok) throw new Error("Failed")
      return response.text().then(html => {
        if (html.trim()) Turbo.renderStreamMessage(html)
      })
    })
  }
}
